import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { PerfilTable } from "./PerfilTable";
import { perfilesStartLoad } from "../../../actions/usuario";
import { PerfilScreen } from "./accesos/PerfilScreen";

const LoadPerfiles = (dispatch) => dispatch(perfilesStartLoad());
export const PerfilListScreen = ({ handleOpenRutaForm }) => {
  const dispatch = useDispatch();
  const handleReload = () => LoadPerfiles(dispatch);
  const { perfiles } = useSelector((state) => state.usuario);
  return (
    <PageHeaderUi
      title="Perfiles"
      subTitle="Listado"
      extra={[
        <ButtonUi
          typeUi={TipoButtonConstants.Actualizar}
          key="actualizar"
          onClick={handleReload}
        />,
        <ButtonUi
          typeUi={TipoButtonConstants.Nuevo}
          key="Nuevo"
          onClick={handleOpenRutaForm}
        />,
      ]}
    >
      <PerfilTable
        perfiles={perfiles}
        handleOpenRutaForm={handleOpenRutaForm}
      />
    </PageHeaderUi>
  );
};
export const PerfilList = () => {
  const dispatch = useDispatch();
  const [openRutaForm, setOpenRutaForm] = useState(false);
  const handleOpenRutaForm = () => setOpenRutaForm(true);
  const handleCloseRutaForm = () => setOpenRutaForm(false);
  useEffect(() => {
    LoadPerfiles(dispatch);
  }, []);
  if (openRutaForm)
    return (
      <PerfilScreen
        openForm={openRutaForm}
        HandleCloseForm={handleCloseRutaForm}
      />
    );
  else return <PerfilListScreen handleOpenRutaForm={handleOpenRutaForm} />;
};
